import { Swiper, Navigation, Pagination, Thumbs, Controller } from 'swiper';
import eventBus from './core/services/event-bus';
import elementExists from './utils/elementExists';

const Carousels = () => {
    Swiper.use([Navigation, Pagination, Thumbs, Controller]);
            
    const relatedContentCarousels = document.querySelectorAll('.product-section-related-content .related-content-swiper').forEach(carousel => {
        const swiper = new Swiper(carousel, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.product-section-related-content .swiper-button-next',
                prevEl: '.product-section-related-content .swiper-button-prev',
            },
            breakpoints: {
                1192: {
                    slidesPerView: 3,
                    spaceBetween: 80
                },
                1600: {
                    slidesPerView: 3,
                    spaceBetween: 120
                }
            }
        });
    })
}

export default Carousels;